export default {

  platform: '',
  userLocationCode: 0,
  isLogin: false,
  accountConfirmed: false,
  usernameConfirmed: false,
  brandName: '$__BRAND_SHORT'
}




// WEBPACK FOOTER //
// ./src/vuex/state.js